const RAW_API_URL: string = process.env.API_URL ?? "";

function trimTrailingSlashes(value: string): string {
  return value.replace(/\/+$/, "");
}

const API_BASE = trimTrailingSlashes(RAW_API_URL);

export const apiMode = API_BASE.length > 0;

/**
 * Build a fully qualified API URL while guarding against `/api/api/...` when
 * API_URL already includes a trailing `/api` segment.
 */
export function apiUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (API_BASE.endsWith("/api") && normalizedPath.startsWith("/api/")) {
    return `${API_BASE}${normalizedPath.slice(4)}`;
  }
  return `${API_BASE}${normalizedPath}`;
}
